import { render, staticRenderFns } from "./ErrorAlert.vue?vue&type=template&id=42e42f2e&"
import script from "./ErrorAlertVue.ts?vue&type=script&lang=ts&"
export * from "./ErrorAlertVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports